"use client";

import {
  resolveImageUrl,
  resolveMenuItemAttributes,
} from "@/storyblok/resolvers";
import { LandingspageData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function Header({ data }: { data: LandingspageData }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const handleResize = () => {
    if (window.innerWidth >= 1160) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let headerClass = isSticky ? "header sticky" : "header";
  if (data.special_class) {
    headerClass += " " + data.special_class;
  }

  return (
    <header
      className={headerClass}
      style={{
        "--color-background": data.header_background_color?.color,
      }}
      {...makeEditable(data)}
    >
      <div className="wrapper">
        <Link href="/" className="logo">
          <img
            src={resolveImageUrl(data.logo, { width: 200 })}
            alt={data.logo.alt}
          />
        </Link>
        <details open={isOpen}>
          <summary>
            <span>Menu</span>
            <a role="button" tabIndex={0}>
              <b></b>
              <b></b>
              <b></b>
            </a>
          </summary>
          <nav className="menu">
            {data.menu_items.map((menu_item) => (
              <Link
                {...resolveMenuItemAttributes(menu_item)}
                key={menu_item._uid}
                {...makeEditable(menu_item)}
              >
                {menu_item.label}
              </Link>
            ))}
            <a className="btn btn-alt" href={`#${data.cta.anchor}`}>
              {data.cta.label}
            </a>
          </nav>
        </details>
      </div>
    </header>
  );
}
